import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import Container from '../../../../../Container/Container';

export interface SSNContainerProps {
  title: TranslationTag;
  pageTopTitle: TranslationTag;
  pageTopSubtitle: React.ReactNode;
  showLockIcon?: boolean;
  page: React.ComponentType;
}

const RMFCompletedContainer: React.FC<React.PropsWithChildren<SSNContainerProps>> = ({
  title,
  pageTopSubtitle,
  pageTopTitle,
  children,
  page
}) => (
  <Container
    page={page}
    headerProps={{
      title: <Translation {...title} />,
      buttons: {}
    }}
    pageTopTitle={<Translation {...pageTopTitle} />}
    pageTopSubtitle={pageTopSubtitle}
  >
    {children}
  </Container>
);

export default RMFCompletedContainer;
